// ✅ Action Types
import * as actionTypes from "../ActionTypes";

// ✅ Fetch Channels
export const fetchChannelsRequest = (payload, callback) => ({
  type: actionTypes.FETCH_CHANNELS_REQUEST,
  payload,
  callback,
});

export const fetchChannelsSuccess = (data) => ({
  type: actionTypes.FETCH_CHANNELS_SUCCESS,
  payload: data,
});

export const fetchChannelsFailure = (error) => ({
  type: actionTypes.FETCH_CHANNELS_FAILURE,
  payload: error,
});

// ✅ Save Channel
export const saveChannelRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CHANNEL_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveChannelSuccess = (data) => ({
  type: actionTypes.SAVE_CHANNEL_SUCCESS,
  payload: data,
});

export const saveChannelFailure = (error) => ({
  type: actionTypes.SAVE_CHANNEL_FAILURE,
  payload: error,
});

// ✅ Delete Channel
export const deleteChannelRequest = (payload, callback) => ({
  type: actionTypes.DELETE_CHANNEL_REQUEST,
  payload,
  callback,
});

export const deleteChannelSuccess = (data) => ({
  type: actionTypes.DELETE_CHANNEL_SUCCESS,
  payload: data,
});

export const deleteChannelFailure = (error) => ({
  type: actionTypes.DELETE_CHANNEL_FAILURE,
  payload: error,
});

// ✅ Update Channel
export const updateChannelRequest = (payload, callback) => ({
  type: actionTypes.UPDATE_CHANNEL_REQUEST,
  payload,
  callback,
});

export const updateChannelSuccess = (data) => ({
  type: actionTypes.UPDATE_CHANNEL_SUCCESS,
  payload: data,
});

export const updateChannelFailure = (error) => ({
  type: actionTypes.UPDATE_CHANNEL_FAILURE,
  payload: error,
});

// ✅ Fetch Channel by ID
export const fetchChannelByIdRequest = (_id, callback) => ({
  type: actionTypes.FETCH_CHANNEL_BY_ID_REQUEST,
  payload: { _id },
  callback,
});

export const fetchChannelByIdSuccess = (channel) => ({
  type: actionTypes.FETCH_CHANNEL_BY_ID_SUCCESS,
  payload: channel,
});

export const fetchChannelByIdFailure = (error) => ({
  type: actionTypes.FETCH_CHANNEL_BY_ID_FAILURE,
  payload: error,
});
